const EnumHelper = {
  getItems: (enumType: any) => {
    return Object.keys(enumType).filter((key) => !isNaN(Number(enumType[key as keyof typeof enumType])));
  },
  getItemKeys: (enumType: any) => {
    return Object.keys(enumType);
  },

  getItemValues: (enumType: any) => {
    return Object.values(enumType);
  },

  getNumericItemValues: (enumType: any) => {
    return Object.keys(enumType)
      .filter((key) => isNaN(Number(enumType[key as keyof typeof enumType])))
      .map((i) => Number(i));
  },

  getNumericItemValue: (enumType: any, items: any) => {
    return Object.keys(enumType)
      .filter((key) => isNaN(Number(enumType[key as keyof typeof enumType])) && items !== key)
      .map((i) => Number(i));
  },

  getRandomEnumKey: (enumerations: any[]) => {
    let enumKeys: any[] = [];

    for (let i = enumerations.length - 1; i >= 0; i--) enumKeys = [...enumKeys, enumerations[i]];

    const randomIndex = Math.floor(Math.random() * enumKeys.length);
    return enumKeys[randomIndex];
  },
};

export default EnumHelper;
